import { Routes } from '@angular/router';
import { ecomCashoutSetecomTestGuard } from './pages/public/ecomcashout/test/guard';

export const routes: Routes = [
  {
    path: 'ecomcashout/setecom/test',
    canMatch: [ecomCashoutSetecomTestGuard],
    loadComponent: () =>
      import('./pages/public/ecomcashout/test/component').then(
        (m) => m.EcomCashoutSetecomTestComponent,
      ),
  },
  // {
  //   path: 'private',
  //   loadChildren: () => import('./pages/private/routes').then((m) => m.routes),
  // },
  {
    path: 'private/settings/identification',
    loadComponent: () =>
      import('./pages/private/settings/identification/component').then(
        (m) => m.IdentificationComponent
      ),
  },
  {
    path: 'insurance',
    loadComponent: () =>
      import('./pages/insurance/component').then((m) => m.Insurance),
  },
  {
    path: 'public/auth2fa',
    loadComponent: () =>
      import('./pages/public/auth2fa/component').then(
        (m) => m.Auth2FAComponent
      ),
    loadChildren: () =>
      import('./pages/public/auth2fa/routes').then((m) => m.routes),
  },
  {
    path: 'public/ecom',
    loadChildren: () =>
      import('./pages/public/ecom/routes').then((m) => m.routes),
  },
];
